import React from 'react';
import {Link } from 'gatsby';
import styled from 'styled-components';


const NavigationNav = styled.nav`
    display: flex;
    flex-basis: 80%;
    height: 100%;

    @media (max-width: 1080px) {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        transform: ${({open}) => open ? 'translateX(0)' : 'translateX(100%)'};
        transition: 0.3s ease-in-out;
    }
`;

const NavWrapper = styled.ul`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    list-style: none;
    width: 100%;

    @media (max-width: 1080px) {
        flex-flow: column nowrap;
        background-color: white;
        height: 100vh;
        width: 100vw;
        padding: 20vh 0 40vh ;
    }
`;

const NavListItem = styled.li`
    position: relative;
    text-decoration: none;
    text-align: center;
    flex-basis: 16%;
    transition: 1.3s ease-in;

    span {
        position: absolute;
        display: block;
        opacity:0;
        bottom: -0.5rem;
        left: 50%;
        width: 20%;
        transform: translateX(-50%);
        height: 0.3rem;
        background-color: #EB6AA4;
        transition: all 0.3s ease-in;
    }
    &:hover {
        span {
            opacity: 1;
            width: 78%;
        }
    }

    @media (max-width: 1080px) {
        height: 1.4rem;

        span {
            top: 3rem;
        }
     }
`;
const NavLink = styled(Link)`
    text-decoration: none;
    font-size: 1.3rem;
    color: black;

    @media (max-width: 1080px) {
        font-size: 2.2rem;
    }
`;

const NavList = ({open}) => (
    <NavigationNav open={open}>
        <NavWrapper open={open}>
            <NavListItem>
                <NavLink to="/">Glowna</NavLink>
                <span></span>
            </NavListItem>
            <NavListItem>
                <NavLink to="/muzycznaobslugawesel">Muzyczna obsluga wesel</NavLink>
                <span></span>
            </NavListItem>
            <NavListItem>
                <NavLink to="/naglosnienie">Naglosnienie i oswietlenie</NavLink>
                <span></span>
            </NavListItem>
            <NavListItem>
                <NavLink to="/prowadzacy">Konferensjerzy i prowadzacy</NavLink>
                <span></span>
            </NavListItem>
            <NavListItem>
                <NavLink to="/uslugidodatkowe">Uslugi dodatkowe</NavLink>
                <span></span>
            </NavListItem>
            <NavListItem>
                <NavLink to="#kontakt">Kontakt</NavLink>
                <span></span>
            </NavListItem>
        </NavWrapper>
    </NavigationNav>
)

export default NavList